/**
 * @flow
 * Created by neo on 06.06.17.
 */

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Alert} from 'reactstrap';

type Props = {
  isOpen: boolean,
  children: any,
  color: string,
  onHide: () => void,
  duration?: number
};

@observer
export default class ShortAlert extends Component {

  props: Props;
  state: {
    isOpen: boolean
  };
  interval = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: props.isOpen
    };
  }

  componentWillReceiveProps(props: Props) {
    this.setState({ isOpen: props.isOpen });
    if(props.isOpen) {
      this.interval = setTimeout(() => {
        this.setState({ isOpen: false });
      }, props.duration || 5000);
    } else {
      if(this.interval) {
        clearTimeout(this.interval);
        this.interval = null;
      }
    }
  }
  
  componentWillUnmount() {
    if(this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  }

  render() {
    if(this.state.isOpen) {
      return (
        <Alert color={this.props.color}>
          {this.props.children}
        </Alert>
      )
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Booking/View/ShortAlert.js